"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var BonusFreespinRangeGameSetsListCtl = /** @class */ (function (_super) {
    __extends(BonusFreespinRangeGameSetsListCtl, _super);
    function BonusFreespinRangeGameSetsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_min_dep_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.min_dep_amount; });
        _this.dk_gameset_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.gameset_id; });
        _this.dk_gameset_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.gameset_title; });
        _this.dk_app_currency_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_id; });
        _this.dk_app_currency_iso = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_iso; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this._errDialog = errDialog;
        return _this;
    }
    BonusFreespinRangeGameSetsListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    BonusFreespinRangeGameSetsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "bonus freespin range gameset with id [" + id + "] not found !";
    };
    BonusFreespinRangeGameSetsListCtl.prototype.LoadData = function (fsRangeId, AllCurrency, currencyId, onDone) {
        var _this = this;
        webAApi_1.ListFSRangeGameSetsByFSRangeAndCurrencyGet.exec({
            fsrange_id: fsRangeId,
            app_currency_id: currencyId,
            all_currencies: AllCurrency
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            //
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    gameset_id: resp.list[i].gameset_id,
                    gameset_title: resp.list[i].gameset_title,
                    app_currency_id: resp.list[i].app_currency_id,
                    app_currency_iso: resp.list[i].app_currency_iso,
                    description: resp.list[i].description,
                    min_dep_amount: resp.list[i].min_dep_amount,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false),
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BonusFreespinRangeGameSetsListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddFSRangeGameSet.exec({
            data: {
                fsrange_id: data.fsrange_id,
                cms_gameset_id: data.cms_gameset_id,
                app_currency_id: data.app_currency_id,
                description: data.description,
                min_dep_amount: data.min_dep_amount
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                gameset_id: data.cms_gameset_id,
                gameset_title: resp.cms_gameset_title,
                app_currency_id: data.app_currency_id,
                app_currency_iso: resp.app_currency_title,
                description: data.description,
                min_dep_amount: data.min_dep_amount,
                date_added: moment(resp.date_added_uts_ms).utc(false),
                date_changed: moment(resp.date_changed_uts_ms).utc(false),
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BonusFreespinRangeGameSetsListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditFSRangeGameSet.exec({
                data: {
                    fsrange_gameset_id: data.key,
                    cms_gameset_id: data.cms_gameset_id,
                    min_amount: data.min_amount,
                    description: data.description,
                }
            }, function (resp) {
                _tmp.gameset_id = data.cms_gameset_id;
                _tmp.gameset_title = resp.cms_gameset_title;
                _tmp.min_dep_amount = data.min_amount;
                _tmp.description = data.description;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BonusFreespinRangeGameSetsListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    BonusFreespinRangeGameSetsListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteFSRangeGameSet.exec({ data: { fs_range_gameset_id: key } }, function (resp) {
                _this.RemoveItem(key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return BonusFreespinRangeGameSetsListCtl;
}(BaseController_1.BaseController));
exports.BonusFreespinRangeGameSetsListCtl = BonusFreespinRangeGameSetsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_fsranges/ctl/BonusFreeSpinRangeGameSetsListCtl.ts
// module id = 1013
// module chunks = 0